"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientRoutes = void 0;
var ClientRoutes;
(function (ClientRoutes) {
    ClientRoutes["BasePrefix"] = "clients";
    ClientRoutes["ById"] = ":clientId";
    ClientRoutes["AllInfoById"] = "all-info/:clientId";
    ClientRoutes["All"] = "all";
    ClientRoutes["List"] = "list";
    ClientRoutes["GenerateExcel"] = "generate-excel";
    ClientRoutes["FilesAll"] = "files-all/:clientId";
})(ClientRoutes = exports.ClientRoutes || (exports.ClientRoutes = {}));
